<template>
    <div id="voice-agent-dashboard">
        <AppBreadCrumb
            :paths="[{ title: 'AI Ses Ajanı', route: '/integrations/voice-agent' }, { title: breadcrumbTitle }]"
        />
        <div class="voice-agent-dashboard-wrapper">
            <SidebarChild
                :items="VoiceAgentMenuTypes"
                :selected-item="activeTab"
                @selected="selectedTab"
                :focusActive="true"
                :defaultOpen="true"
            />
            <div class="page-content">
                <template v-if="activeTab === 'agents'">
                    <AgentEditor
                        v-if="selectedAgentId"
                        :channelId="channelId"
                        :agentId="selectedAgentId"
                        :activeTab="agentEditorActiveTab"
                        @back="clearSelectedAgent"
                    />
                    <AgentList v-else :channelId="channelId" />
                </template>
                <KnowledgeBase v-else-if="activeTab === 'knowledge-base'" :channelId="channelId" />
                <PhoneNumbers v-else-if="activeTab === 'phone-numbers'" :channelId="channelId" />
                <BatchCall v-else-if="activeTab === 'batch-call'" :channelId="channelId" />
                <CallHistory v-else-if="activeTab === 'call-history'" :channelId="channelId" />
                <AutomationList type="event" module="voiceagent" v-else-if="activeTab === 'automations'" />
            </div>
        </div>
    </div>
</template>

<script>
import "./voice-agent-dashboard.scss";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import { mapGetters } from "vuex";
import VoiceAgentMenuTypes from "./VoiceAgentMenuTypes";

// Component imports
import AgentList from "./pages/agents/AgentList.vue";
import AgentEditor from "./pages/agents/AgentEditor.vue";
import KnowledgeBase from "./pages/KnowledgeBase.vue";
import PhoneNumbers from "./pages/PhoneNumbers.vue";
import BatchCall from "./pages/BatchCall.vue";
import CallHistory from "./pages/CallHistory.vue";
import AutomationList from "../../Automation/pages/automations/AutomationList.vue";
export default {
    name: "VoiceAgentDashboard",
    components: {
        AppBreadCrumb,
        SidebarChild,
        AgentList,
        AgentEditor,
        KnowledgeBase,
        PhoneNumbers,
        BatchCall,
        CallHistory,
        AutomationList,
    },
    props: {
        channelId: {
            type: String,
            required: true,
        },
        tab: {
            type: String,
            default: null,
        },
    },
    data() {
        const menuItems = VoiceAgentMenuTypes(this);
        return {
            VoiceAgentMenuTypes: menuItems,
            activeTab: this.getInitialActiveTab(),
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        selectedAgentId() {
            return this.$route.query.agent_id || null;
        },
        agentEditorActiveTab() {
            return this.$route.query.editor_tab || "agent";
        },
        breadcrumbTitle() {
            // Aktif sekmenin adını bul ve döndür
            const activeMenuItem = this.VoiceAgentMenuTypes.find((item) => item.key === this.activeTab);
            return activeMenuItem ? activeMenuItem.label : "Dashboard";
        },
    },
    methods: {
        getInitialActiveTab() {
            // Öncelik sırası: props.tab > route.params.tab > URL'deki query.tab > 'agents'
            if (this.tab) {
                return this.tab;
            }

            if (this.$route.params.tab) {
                return this.$route.params.tab;
            }

            if (this.$route.query.tab) {
                return this.$route.query.tab;
            }

            return "agents";
        },
        selectedTab({ key }) {
            this.activeTab = key;
            this.$router.push({
                path: `/integrations/voice-agent/${this.channelId}/dashboard/${key}`,
                query: { tab: key }, // URL'ye tab parametresi ekle
            });
        },
        clearSelectedAgent() {
            this.$router.push({
                path: this.$route.path,
                query: { tab: this.activeTab },
            });
        },
    },
    created() {
        // Route değişiklikleri izle
        this.$nextTick(() => {
            // URL'deki tab parametresini Vue state ile senkronize et
            if (this.$route.query.tab) {
                this.activeTab = this.$route.query.tab;
            }
        });
    },
    watch: {
        $route(to) {
            // Route değişikliklerinde tab parametresini kontrol et
            if (to.query.tab) {
                this.activeTab = to.query.tab;
            } else if (to.params.tab) {
                this.activeTab = to.params.tab;
            }
        },
    },
};
</script>
